module.exports = __webpack_public_path__ + "img/logo-collapsed.c81eaf96.png";